module.exports = __webpack_public_path__ + "static/media/33.bf150f3c.jpg";